import React from 'react';
import { Input, Button, PaperClip, Select, CheckboxTable } from 'components';
import { ClinicService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { LocationIcon } from 'assets/icons';
import moment from 'moment';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalWork extends React.Component<Props> {
	
	render() {
		return (
			<div id="modal-users-work">
				<div className="row">
					<div className="col-12">
						<h3>Establecimientos donde presta servicios</h3>
						<div className="container-establishments">
							{
								this.props.item?.establishments?.map((item: any) => {
									return (
										<div className="item-establishment">
											<img src={ LocationIcon } />
											<div>
												<p>{ item.name }</p>
												<p>{ item.address }</p>
												<p>{ item.schedule_since != null ? moment(item.schedule_since,'HH:mm:ss').format('HH:mm') : '' } { item.schedule_since != null && item.schedule_until ? '-' : '' } { item.schedule_until != null ? moment(item.schedule_until,'HH:mm:ss').format('HH:mm') : '' }</p>
											</div>
										</div>
									)
								})
							}
						</div>
					</div>
					<div className="col-12">
						<div className="row row-buttons">
							<div className="col-md-12 text-center">
								<Button type="button" onClick={ () => this.props.onClose() }>
									Cerrar
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default ModalWork;